import { GretaAIChatLimitNotice } from '../GretaAIChatLimitNotice'
import { GretaAIChatSourceOutageNotice } from '../GretaAIChatSourceOutageNotice'
import { GretaAIChatSourceRevokedNotice } from '../GretaAIChatSourceRevokedNotice'

import { GretaAIChatStripNoticeType } from './GretaAIChatStripNotice.constants'

export function getGretaAIChatStripNotice({
  isLimitReached,
  isLocked,
  isSourceOutage,
  isSourceRevoked,
}) {
  if (isLimitReached && !isLocked) {
    return GretaAIChatStripNoticeType.Limit
  }

  if (isSourceRevoked) {
    return GretaAIChatStripNoticeType.Revoked
  }

  return isSourceOutage ? GretaAIChatStripNoticeType.Outage : null
}

export function getGretaAIChatStripNoticeContent({ notice, onRetry }) {
  switch (notice) {
    case GretaAIChatStripNoticeType.Limit:
      return <GretaAIChatLimitNotice />
    case GretaAIChatStripNoticeType.Outage:
      return <GretaAIChatSourceOutageNotice onRetry={onRetry} />
    case GretaAIChatStripNoticeType.Revoked:
      return <GretaAIChatSourceRevokedNotice />
    default:
      return null
  }
}
